import { render, staticRenderFns } from "./newOpen1.vue?vue&type=template&id=362462ae&scoped=true&"
import script from "./newOpen1.vue?vue&type=script&lang=js&"
export * from "./newOpen1.vue?vue&type=script&lang=js&"
import style0 from "./newOpen1.vue?vue&type=style&index=0&id=362462ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362462ae",
  null
  
)

export default component.exports